import axios from 'axios'
import InfoOptionStore from '../stores/infoOptionStore'

export const ParentWorkScheduleRequest = {
  getWorkSchedule: (from_date, to_date, company_work_schedule, apiUrl) => {
    const { API_URL, CODE } = InfoOptionStore.infoOptionList || {}

    return axios({
      method: 'get',
      url: `${apiUrl || API_URL}/api/v1/work-schedules`,
      params: {
        from_date,
        to_date,
        is_current: true,
        company_work_schedule: company_work_schedule || CODE,
      },
    })
  },
  getWorkScheduleDetail: scheduleCode => {
    const { API_URL } = InfoOptionStore.infoOptionList

    return axios({
      method: 'get',
      url: `${API_URL}/api/v1/work-schedules/${scheduleCode}`,
      params: {},
    })
  },
}
